export const TEMPLATE_IDS = {
  RESULTS: 5,
  VILLA: 17,
  ENQUIRY: 15,
  HOME: 3,
};

export const PAGE_IDS = {
  SHORTLISTTHANKS: 55,
  SHARED_SHORTLIST: 932,
};

// think exquisite - 20
// experiences - 21
// regions - 24
// greek islands - 64
// careers - 2
// confirm booking - 27
// payment - 29
// login - 31
// my booking -34
// personal profile - 35
// subscription preferences - 36 - not returning as secure
// guest logins - 37

// MOBILE SEARCH BUTTON - EXLUDED TEMPLATE IDS
export const MSB_EXCLUDED_TEMPLATE_IDS = [0, 3, 5, 17, 15, 20, 21, 24, 26, 27, 29, 31, 36, 64, 65, 68, 69, 71, 72, 73, 75, 76, 82, 83, 88];

export const MSB_EXCLUDED_PAGE_IDS = [55, 911, 1059, 1060, 1061, 1062, 1063, 1087, 1093, 48];

// Exclude Main nav and Footer (used on SCA)
export const NAV_EXCLUDED_TEMPLATE_IDS = [31, 34, 35, 36, 37, 39, 44, 47, 48, 49, 51, 52, 53, 54, 56, 57, 58, 59, 60, 61, 67, 74, 75, 76, 79, 80, 81, 84, 85, 87];
// export const NAV_EXCLUDED_PAGE_IDS = [];
